import UserReportsClient from '@/api/CampusAdmin/UserReportsClient';

export default class DemographicsReport {
  constructor() {
    this.client = null;
    this.schoolId = 0;
    this.customCampusTags = [];

    this.loading = true;
    this.error = null;
    this.data = {};
  }

  async initialize($http, schoolId) {
    this.client = new UserReportsClient($http);
    this.schoolId = schoolId;
    await this.fetch();
  }

  withCustomTags(tags) {
    this.customCampusTags = tags;
    this.fetch();
  }

  async fetch() {
    try {
      this.loading = true;

      const response = await this.client.getUserDemographics(
        this.schoolId,
        this.customCampusTags
      );

      this.data = {
        totalActiveStudents: response.totalUsers,
        demographics: { },
        concerns: response.concerns.map(x => ({
          answer_text: x.name,
          number_of_responses: x.count
        }))
      }

      response.ethnicities.forEach((ethnicity) => {
        if (ethnicity.name == null) {
          this.data.demographics.race_prefer_not_to_answer = ethnicity.count;
        } else {
          this.data.demographics[`race_${ethnicity.name}`] = ethnicity.count;
        }
      });

      response.genders.forEach((gender) => {
        if (gender.name != null) {
          this.data.demographics[`gender_${gender.name}`] = gender.count;
        }
      });
    } catch (error) {
      console.error(error);
      this.error = error;
    } finally {
      this.loading = false;
    }
  }
}
